import React from "react";
import DashboardLayout from "../DashboardLayout";
import ServicesContent from "../../../../components/ServicesContent";

function Services({ user }) {
  return (
    <DashboardLayout user={user}>
      <ServicesContent />
    </DashboardLayout>
  );
}

export default Services;
